<template>
    <nav id="nav-bar" class="d-flex justify-content-between align-items-center pe-4">
        <a href="/home" class="logo"></a>
        <div class="d-flex align-items-center" v-if="change_language">
            <div class="menu-item select-lang me-3" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#selectLangModal">
                <img class="flag" :src="selectedLocale?.img_flag" alt="" />
            </div>
        </div>
    </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { getConfigs, getLanguage } from "../utils/utils";

export default {
    name: "NavBarAuth",
    props: ['change_language'],
    data() {
        const configs = getConfigs();
        const lang = getLanguage();
        const selectedLocale = configs.localize?.find(locale => locale.lang === lang)

        return {
            user: { name: 'Guest' },
            lang,
            selectedLocale
        };
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        })
    },
    mounted() {
        if (this.lang == 'vi') {
            $.datepicker.setDefaults($.datepicker.regional['vi']);
        } else {
            $.datepicker.setDefaults($.datepicker.regional['']);
        }
    }
}
</script>

<style scoped>
</style>
